// What Discard puts back for changes set aside (refused.ts), decided here so it
// can be tested without a device database. Pure.
const HTTP_NOT_FOUND = 404;
const HTTP_FORBIDDEN = 403;
/** GET /api/jobs's 403 for a user no longer allowed into the app (api/src/shared/auth.ts asUser). */
const NOT_ENTITLED = 'NOT_ENTITLED';

/**
 * Reading the job from CRM for Discard failed. Returns when that means "CRM has
 * no copy this user can see" (so what never reached CRM is dropped): only a
 * 404 — the job no longer opens for them. Losing access to the app says
 * nothing about CRM's copy, so Discard stops and keeps every change; anything
 * else is rethrown.
 */
export function assertNoCrmCopy(err: unknown): void {
  const { status, code } = (typeof err === 'object' && err !== null ? err : {}) as { status?: unknown; code?: unknown };
  if (status === HTTP_NOT_FOUND) return;
  if (status === HTTP_FORBIDDEN && code === NOT_ENTITLED) {
    throw new Error('You don’t have access to Measure2Quote right now, so nothing was discarded. Your changes are kept on this iPad.');
  }
  throw err;
}
